<template>
    <div>
        <rkm-form
            ref="Form"
            show-legend
            v-if="loaded"
        >
            <rkm-area
                type="fieldset"
                title="Identificação do paciente"
            >
                <FormCidadao
                    :model="model"
                />
            </rkm-area>

            <rkm-area
                type="fieldset"
                title="Profissional responsável"
                show-legend
            >
                <FormProfissional
                    :repositories="repositories"
                    :model="model"
                    :enums="enums"
                    :form="form"
                    :agendamento="agendamento"
                    :isAmbulatorio="isAmbulatorio"
                />
            </rkm-area>

            <rkm-area
                type="fieldset"
                title="Atendimento"
            >
                <FormAtendimento
                    :model="model"
                    :form="form"
                />
            </rkm-area>

            <rkm-area
                type="fieldset"
                title="Vigilância em saúde bucal *"
            >
                <FormVigilancia
                    :model="model"
                />
            </rkm-area>

            <rkm-area
                type="fieldset"
                title="Procedimentos(Quantidade)"
            >
                <FormQuantidade
                    :model="model"
                />
            </rkm-area>

            <rkm-area
                type="fieldset"
                title="Procedimentos"
                class="mt-3"
            >

                <rkm-button
                    @click="$refs.Modal.open()"
                    color="primary"
                    slot="trailing"
                    title="Adicionar"
                    small
                    :disabled="model.exportacao"
                >
                    <rkm-icon icon="plus"/>
                </rkm-button>

                <FormProcedimentos
                    :model="model"
                />
            </rkm-area>

            <rkm-area
                type="fieldset"
                title="Fornecimento"
            >
                <FormFornecimento
                    :model="model"
                />
            </rkm-area>

            <rkm-area
                type="fieldset"
                title="Conduta/ Desfecho *"
                no-margin-top
            >
                <FormCondutaEncaminhamento
                    :model="model"
                />
            </rkm-area>

        </rkm-form>

        <Modal
            :model="model"
            :form="form"
            :loaded="loaded"
            :repositories="repositories"
            ref="Modal"
        />
    </div>
</template>

<script>
import { repository, stringCase, data, object, formats, error } from "@/mixins";
import permissao from '@/enums/atencao-basica/parametrizacao/permissao'
import procedimento from '@/enums/atencao-basica/atendimento-odontologico/procedimento'
import tipoAtendimento from '@/enums/atencao-basica/atendimento-individual/tipoAtendimento'
import { mapActions } from "vuex";
import moment from 'moment'

import FormCidadao from './components/cidadao/Form.vue'
import FormProfissional from './components/profissional/Form.vue'
import FormAtendimento from './components/atendimento/Form.vue'
import FormVigilancia from './components/vigilancia/Form.vue'
import FormQuantidade from './components/quantidade/Form.vue'
import FormProcedimentos from './components/procedimento/Form.vue'
import FormFornecimento from './components/fornecimento/Form.vue'
import FormCondutaEncaminhamento from './components/condutaEncaminhamento/Form.vue'
import Modal from './components/procedimento/Modal'

export default {
    components: {
        FormCidadao,
        FormProfissional,
        FormAtendimento,
        FormVigilancia,
        FormQuantidade,
        FormProcedimentos,
        FormFornecimento,
        FormCondutaEncaminhamento,
        Modal
    },
    created() {
        this.repositories = {
            procedimento: this.getConectaSusRepository('sigtap.procedimento'),
            usuario: this.getConectaSusRepository('cadastro.sujeitoAtencao.usuario'),
            atendimentoOdontologico: this.getConectaSusRepository('atencaoBasica.atendimentoOdontologico')
        }
        this.load()
    },
    data: () => ({
        index: null,
        form: null,
        model: null,
        loaded: false,
        agendamento: null,
        enums: {
            permissao,
            procedimento,
            tipoAtendimento
        }
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            if (this.id && !this.edit) {
                this.setLoading()
                this.repositories.atendimentoOdontologico.create(this.id)
                    .then(response => {
                        this.model = Object.assign(response.data.model)
                        this.form = Object.assign(response.data.form)

                        if (this.isAmbulatorio) {

                            this.$nextTick()
                                .then(() => {

                                    if (this.data.model.atendimentoOdontologico) {

                                        this.model = this.data.model.atendimentoOdontologico
                                    } else {

                                        this.model.cadastro.usuario = this.data.model.cadastro.usuario
                                        this.model.cadastro.unidadeId = this.data.model.cadastro.unidadeId
                                        this.model.cadastro.infraestruturaId = this.data.model.cadastro.infraestruturaId
                                        this.model.cadastro.equipeId = this.data.model.cadastro.equipeId
                                        this.model.cadastro.ocupacaoId = this.data.model.cadastro.ocupacaoId
                                        this.model.cadastro.dataUsuarioResponsavel = this.data.model.cadastro.dataUsuarioResponsavel
                                    }

                                    this.agendamento = this.data
                            })
                        }

                        this.$nextTick().then(() => this.loaded = true)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            } else if (this.edit) {
                this.setLoading()
                this.repositories.atendimentoOdontologico.edit(this.id)
                    .then(response => {
                        this.model = Object.assign(response.data.model)
                        this.form = Object.assign(response.data.form)
                        this.loaded = true
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        save() {
            this.$refs.Form.validate()
                .then(valid => {
                    if (!valid) return
                    if(this.edit) {
                        this.setLoading()
                        this.repositories.atendimentoOdontologico.update(this.id, this.prepareData())
                            .then(({ data }) => {
                                this.showSaveNotification()
                                this.$emit('save', data)
                            })
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading())
                    }
                    else {
                        this.setLoading()
                        this.repositories.atendimentoOdontologico.store(this.prepareData())
                            .then(({ data }) => {
                                this.showSaveNotification()
                                this.$emit('save', data)
                            })
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading())
                    }
            })
        },
        saveAmbulatorio() {

            return this.$refs.Form.validate()
                .then(valid => {

                    if (!valid) {

                        this.$emit('focusTabAtendimentoOdontologico')
                        return false
                    } else {

                        this.$emit('saveAtendimentoOdontologico', this.model)
                        return true
                    }
            })
        },
        saveProcedimento() {
            const param = {
                id: this.model.procedimento.id,
                nome: this.model.procedimento.nome,
                codigo: this.model.procedimento.codigo,
            }
            if (this.index) {
                this.$set(this.model.procedimentos, this.index, this.clone(param))
            } else {
                this.model.procedimentos.push(this.clone(param))
            }

            this.resetForm()
        },
        prepareData() {
            return this.camelObjectKeysToSnakeRecursive({
                pacienteId: this.model.cidadao.pacienteId,
                usuarioId: this.model.cadastro.usuario.id,
                ocupacaoId: this.model.cadastro.ocupacaoId,
                usuarioAuxiliarId: this.model.cadastro.usuarioAuxiliar.id,
                ocupacaoAuxiliarId: this.model.cadastro.ocupacaoAuxiliarId,
                dataAtendimento: moment(this.model.cadastro.dataAtendimento).format('YYYY-MM-DD'),
                turnoId: this.model.atendimento.turnoId,
                localAtendimentoId: this.model.atendimento.localAtendimentoId,
                tipoAtendimentoId: this.model.atendimento.tipoAtendimentoId,
                tipoConsultaId: this.model.atendimento.tipoConsultaId,
                necessidadesEspeciais: this.model.atendimento.necessidadesEspeciais,
                gestante: this.model.atendimento.gestante,
                unidadeId: this.model.cadastro.unidadeId,
                equipeId: this.model.cadastro.equipeId,
                equipeAuxiliarId: this.model.cadastro.equipeAuxiliarId,
                escovaDental: this.model.fornecimento.escovaDental,
                cremeDental: this.model.fornecimento.cremeDental,
                fioDental: this.model.fornecimento.fioDental,
                vigilancia: this.model.vigilancia,
                condutaEncaminhamento: this.model.condutaEncaminhamento,
                procedimentos: this.prepareProcedimentos()
            })
        },
        prepareProcedimentos() {
            let procedimentos = this.clone(this.model.procedimentos)
            if(this.model.procedimentosQuantidade.acessoPolpaDentaria) {
                procedimentos.push({
                    codigo: this.enums.procedimento.ACESSO_POLPA_DENTARIA,
                    quantidade: this.model.procedimentosQuantidade.acessoPolpaDentaria
                })
            }
            if(this.model.procedimentosQuantidade.adaptacaoProteseDentaria) {
                procedimentos.push({
                    codigo: this.enums.procedimento.ADAPTACAO_PROTESE_DENTARIA,
                    quantidade: this.model.procedimentosQuantidade.adaptacaoProteseDentaria
                })
            }
            if(this.model.procedimentosQuantidade.aplicacaoCariostatico) {
                procedimentos.push({
                    codigo: this.enums.procedimento.APLICACAO_CARIOSTATICO,
                    quantidade: this.model.procedimentosQuantidade.aplicacaoCariostatico
                })
            }
            if(this.model.procedimentosQuantidade.aplicacaoSelante) {
                procedimentos.push({
                    codigo: this.enums.procedimento.APLICACAO_SELANTE,
                    quantidade: this.model.procedimentosQuantidade.aplicacaoSelante
                })
            }
            if(this.model.procedimentosQuantidade.aplicacaoTopicaFluor) {
                procedimentos.push({
                    codigo: this.enums.procedimento.APLICACAO_TOPICA_FLUOR,
                    quantidade: this.model.procedimentosQuantidade.aplicacaoTopicaFluor
                })
            }
            if(this.model.procedimentosQuantidade.capeamentoPulpar) {
                procedimentos.push({
                    codigo: this.enums.procedimento.CAPEAMENTO_PULPAR,
                    quantidade: this.model.procedimentosQuantidade.capeamentoPulpar
                })
            }
            if(this.model.procedimentosQuantidade.cimentacaoProtese) {
                procedimentos.push({
                    codigo: this.enums.procedimento.CIMENTACAO_PROTESE_DENTARIA,
                    quantidade: this.model.procedimentosQuantidade.cimentacaoProtese
                })
            }
            if(this.model.procedimentosQuantidade.curativoDemora) {
                procedimentos.push({
                    codigo: this.enums.procedimento.CURATIVO_DEMORA,
                    quantidade: this.model.procedimentosQuantidade.curativoDemora
                })
            }
            if(this.model.procedimentosQuantidade.drenagemAbscesso) {
                procedimentos.push({
                    codigo: this.enums.procedimento.DRENAGEM_ABSCESSO,
                    quantidade: this.model.procedimentosQuantidade.drenagemAbscesso
                })
            }
            if(this.model.procedimentosQuantidade.evidenciacaoPlacaBacteriana) {
                procedimentos.push({
                    codigo: this.enums.procedimento.EVIDENCIACAO_PLACA_BACTERIANA,
                    quantidade: this.model.procedimentosQuantidade.evidenciacaoPlacaBacteriana
                })
            }
            if(this.model.procedimentosQuantidade.exodontiaDenteDeciduo) {
                procedimentos.push({
                    codigo: this.enums.procedimento.EXODONTIA_DENTE_DECIDUO,
                    quantidade: this.model.procedimentosQuantidade.exodontiaDenteDeciduo
                })
            }
            if(this.model.procedimentosQuantidade.exodontiaDenteDeciduo) {
                procedimentos.push({
                    codigo: this.enums.procedimento.EXODONTIA_DENTE_PERMANENTE,
                    quantidade: this.model.procedimentosQuantidade.exodontiaDentePermanente
                })
            }
            if(this.model.procedimentosQuantidade.instalacaoProteseDentaria) {
                procedimentos.push({
                    codigo: this.enums.procedimento.INSTALACAO_PROTESE_DENTARIA,
                    quantidade: this.model.procedimentosQuantidade.instalacaoProteseDentaria
                })
            }
            if(this.model.procedimentosQuantidade.moldagemProteseDentaria) {
                procedimentos.push({
                    codigo: this.enums.procedimento.MOLDAGEM_PROTESE_DENTARIA,
                    quantidade: this.model.procedimentosQuantidade.moldagemProteseDentaria
                })
            }
            if(this.model.procedimentosQuantidade.orientacaoHigieneBucal) {
                procedimentos.push({
                    codigo: this.enums.procedimento.ORIENTACAO_HIGIENE_BUCAL,
                    quantidade: this.model.procedimentosQuantidade.orientacaoHigieneBucal
                })
            }
            if(this.model.procedimentosQuantidade.remocaoPlacaBacteriana) {
                procedimentos.push({
                    codigo: this.enums.procedimento.REMOCAO_PLACA_BACTERIANA,
                    quantidade: this.model.procedimentosQuantidade.remocaoPlacaBacteriana
                })
            }
            if(this.model.procedimentosQuantidade.pulpotomiaDentaria) {
                procedimentos.push({
                    codigo: this.enums.procedimento.PULPOTOMIA_DENTARIA,
                    quantidade: this.model.procedimentosQuantidade.pulpotomiaDentaria
                })
            }
            if(this.model.procedimentosQuantidade.raspagemSupragengivais) {
                procedimentos.push({
                    codigo: this.enums.procedimento.RESPAGEM_SUPRAGENGIVAIS,
                    quantidade: this.model.procedimentosQuantidade.raspagemSupragengivais
                })
            }
            if(this.model.procedimentosQuantidade.raspagemSubgengivais) {
                procedimentos.push({
                    codigo: this.enums.procedimento.RASPAGEM_SUBGENGIVAIS,
                    quantidade: this.model.procedimentosQuantidade.raspagemSubgengivais
                })
            }
            if(this.model.procedimentosQuantidade.restauracaoDentePermanenteAnterior) {
                procedimentos.push({
                    codigo: null,
                    quantidade: this.model.procedimentosQuantidade.restauracaoDentePermanenteAnterior
                })
            }
            if(this.model.procedimentosQuantidade.selamentoProvisorioCavidadeDentaria) {
                procedimentos.push({
                    codigo: this.enums.procedimento.ULOTOMIA_ULECTOMIA,
                    quantidade: this.model.procedimentosQuantidade.selamentoProvisorioCavidadeDentaria
                })
            }
            if(this.model.procedimentosQuantidade.tratamentoAlveolite) {
                procedimentos.push({
                    codigo: this.enums.procedimento.ULOTOMIA_ULECTOMIA,
                    quantidade: this.model.procedimentosQuantidade.tratamentoAlveolite
                })
            }
            if(this.model.procedimentosQuantidade.ulotomiaUlectomia) {
                procedimentos.push({
                    codigo: this.enums.procedimento.ULOTOMIA_ULECTOMIA,
                    quantidade: this.model.procedimentosQuantidade.ulotomiaUlectomia
                })
            }
            return procedimentos
        },
        hasValue(atendimento) {

            return Object.keys(atendimento).some(key => {

                if (key === 'turnoId' || key === 'localAtendimentoId' || key === 'tipoAtendimentoId') {
                    return false;
                }

                const value = atendimento[key];
                return value !== "" && value !== null && value !== false && (!Array.isArray(value) || value.length > 0);
            });
        },
    },
    mixins: [repository, stringCase, data, object, formats, error],
    props: {
        id: { type: Number, default: null },
        edit: { type: Boolean, required: false },
        isAmbulatorio: { type: Boolean, default: false },
        data: { type: Object, required: false },
    },
    watch: {
        'model': {
            handler(atendimento) {

                if (this.hasValue(atendimento.vigilancia) || this.hasValue(atendimento.condutaEncaminhamento)
                    || this.hasValue(atendimento.fornecimento) || this.hasValue(atendimento.atendimento)
                    || this.hasValue(atendimento.procedimentosQuantidade)
                    || this.hasValue(atendimento.procedimentos
                        .filter(procedimento => procedimento.origem == 'atencaoBasica'))) {

                            this.$emit('handleAtendimentoOdontologico', true)
                } else if (atendimento.cadastro.equipeId || atendimento.cadastro.usuarioAuxiliar
                    && atendimento.cadastro.usuarioAuxiliar.id) {

                        this.$emit('handleAtendimentoOdontologico', true)
                } else {

                    this.$emit('handleAtendimentoOdontologico', false)
                }
            },
            deep: true
        }
    }
}
</script>